import { z } from 'zod';
import { HttpErrorResponse } from '../../common/validation-error';
import { CmsProjectDefinitionSchema } from './applied-project';
export const createCmsProjectRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/cms/projects',
    name: 'create-cms-project',
    request: { body: CmsProjectDefinitionSchema },
    responses: {
        200: CmsProjectDefinitionSchema,
        201: CmsProjectDefinitionSchema,
        400: HttpErrorResponse,
        409: HttpErrorResponse,
    },
};
export const updateCmsProjectRoute = {
    version: 1,
    method: 'PUT',
    path: '/admin/cms/projects/{slug}',
    name: 'update-cms-project',
    request: {
        params: z.object({ slug: z.string().min(1) }),
        body: CmsProjectDefinitionSchema.omit({ slug: true }),
    },
    responses: {
        200: CmsProjectDefinitionSchema,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
